import {
  RelatedEntityRelationshipType,
  RelatedEntityType,
} from "../../Types/GlobalTypes";

export default class RelatedEntityRelationship {
  public entityId: string = null;
  public entityType: RelatedEntityType = null;
  public entityRelationship: RelatedEntityRelationshipType = null;
}
